export interface PairState {

}

export const initialState: any = []